import React from 'react';
import { Box } from '@mui/material';

const RightSection = () => {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: '100%',
        height: '100vh',
        zIndex: 1,
        overflow: 'hidden',
        display: { xs: 'none', md: 'block' } // Hide on mobile for clean white background
      }}
    >
      {/* Background Image - full width but only visible behind right portion */}
      <Box
        component="img"
        src="/car-bg.png"
        alt="Car Background"
        sx={{
          width: { xs: '100%', md: '50%' },
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'right center',
          position: 'absolute',
          top: 0,
          right: 0,
          left: 'auto',
          WebkitMaskImage: 'url(/bg-curve-mask.png)',
          maskImage: 'url(/bg-curve-mask.png)',
          WebkitMaskSize: '100% 100%',
          maskSize: '100% 100%',
          WebkitMaskPosition: 'center',
          maskPosition: 'center',
          WebkitMaskRepeat: 'no-repeat',
          maskRepeat: 'no-repeat',
        }}
      />
      {/* Dark Overlay with identical mask so overlay only covers the car */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          right: 0,
          left: 'auto',
          width: { xs: '100%', md: '50%' },
          height: '100%',
          background:
            'linear-gradient(90deg, rgba(245,245,245,0.3) 0%, rgba(0,0,0,0.25) 40%, rgba(0,0,0,0.2) 100%)',
          WebkitMaskImage: 'url(/bg-curve-mask.png)',
          maskImage: 'url(/bg-curve-mask.png)',
          WebkitMaskSize: '100% 100%',
          maskSize: '100% 100%',
          WebkitMaskPosition: 'center',
          maskPosition: 'center',
          WebkitMaskRepeat: 'no-repeat',
          maskRepeat: 'no-repeat',
        }}
      />
    </Box>
  );
};

export default RightSection;
